import { Currency } from "slotworks/services/currency/currency";

export class VCurrency extends Currency {

    public format(value: number, trailingDecimals: boolean = true, forceCreditMode?: boolean): string {

        if (value === null) {
            value = 0;
        }

        return V.API.Core.convertCurrency(value.toString());
    }
}
